import { withSearch } from '@elastic/react-search-ui';
import YearRangeFilters from '../../../components/filter/YearRangeFilter';

function HeritageGatewayDateRangeFilter({
  addFilter,
  setFilter,
  removeFilter,
  filters,
}) {
  return (
    <YearRangeFilters
      addFilter={addFilter}
      filters={filters}
      formHint="For example, 2007 AD"
      fromFieldId="monumentDateMin"
      id="historical-date-range"
      label="Date"
      removeFilter={removeFilter}
      setFilter={setFilter}
      toFieldId="monumentDateMax"
    />
  );
}

export default withSearch(
  ({ addFilter, removeFilter, setFilter, filters }) => ({
    addFilter,
    setFilter,
    removeFilter,
    filters,
  }),
)(HeritageGatewayDateRangeFilter);
